// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQ4D9h6yEYzQLyBjxJXtMfK07yGya_w0M",
  authDomain: "inventory-app-61f21.firebaseapp.com",
  projectId: "inventory-app-61f21",
  storageBucket: "inventory-app-61f21.appspot.com",
  messagingSenderId: "154968139018",
  appId: "1:154968139018:web:79030c976346d7d20ec6f3"
};

// Initialize Firebase
initializeApp(firebaseConfig);
